// extracted by mini-css-extract-plugin
module.exports = {"shareSlider":"ShareSlider_shareSlider__uinec","swiper-slide":"swiper-slide","swiper-pagination-lock":"swiper-pagination-lock","custom-navigation":"custom-navigation"};